import { ApiValidationErrors } from "store/types";

type InitialValues = {
  [key: string]: any;
};

type ResultErrors = {
  [key: string]: string;
};

export default (
  initialValues: InitialValues,
  apiErrors: ApiValidationErrors
): ResultErrors => {
  const keysOfApiErrors = Object.keys(apiErrors);
  const keysOfValues = Object.keys(initialValues);

  const result: ResultErrors = {};

  keysOfApiErrors.forEach((error: string) => {
    if (keysOfValues.includes(error)) {
      const errorArray = apiErrors[error];
      if (Array.isArray(errorArray) && errorArray.length > 0) {
        result[error] = errorArray[0];
      } else if (typeof errorArray === "string") {
        result[error] = errorArray;
      }
    }
  });

  return result;
};
